import { getParentIFrame } from './getParentIFrame.js';
import { setIframePageInfo } from './iframePageInfo.js';
import { EVENT_GET_PAGE_INFO } from './IframePageInfoListener.js';

const dispatchIframeResizerEvent = () => {
    if (typeof window === 'undefined') {
        return undefined;
    }
    getParentIFrame()?.getPageInfo((data) => {
        setIframePageInfo(data);
        document.dispatchEvent(new CustomEvent(EVENT_GET_PAGE_INFO, {
            detail: data,
            bubbles: true,
        }));
    });
};

export { dispatchIframeResizerEvent };
//# sourceMappingURL=dispatchIframeResizerEvent.js.map
